import { MEMBER_ACTIONS_PERMISSIONS } from '@bo-constants/permissions';
import { createSelector } from '@reduxjs/toolkit';
import { selectMemberTransactionMaxes } from '@bo-services/authenticationSlice';

const { MEMBER_CREATE_ADJUSTMENT_TRANSACTION_MAX } = MEMBER_ACTIONS_PERMISSIONS;

export const selectCreateAdjusmentMaxLimit = createSelector(
  [selectMemberTransactionMaxes],
  (memberTransactionMaxes) => {
    const createAdjustmentMaxLimit = memberTransactionMaxes.find(
      (transactionMax) =>
        transactionMax.permission_name ===
        MEMBER_CREATE_ADJUSTMENT_TRANSACTION_MAX
    )?.dollar_amount;

    if (createAdjustmentMaxLimit !== undefined) {
      return Math.abs(createAdjustmentMaxLimit);
    }

    return undefined;
  }
);
